import { Locale } from '@tuic/i18n';
import { ComponentBlock } from '@modules/prism-client/types/types';
import { ContentCard, type ContentCardProps } from '@tuic/web-compositions/shared/ContentCard';
export type ContentCardBlockData = ContentCardProps;
export const ContentCardBlock: ComponentBlock<ContentCardBlockData> = ({
  data,
  fallback
}) => {
  if (fallback) {
    return <ContentCard fallback />;
  }
  if (!data) {
    return null;
  }
  return <ContentCard {...data} data-sentry-element="ContentCard" data-sentry-component="ContentCardBlock" data-sentry-source-file="ContentCardBlock.tsx" />;
};